<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="512"
    @click:outside="dialog = false"
  >
    <template #activator="{ props }">
      <v-btn color="blue-darken-1" variant="tonal" v-bind="props" class="ml-2"
        >Sim</v-btn
      >
    </template>

    <v-card>
      <v-card-title class="headline"> Confirmação </v-card-title>
      <v-card-text> Você tem certeza que deseja fazer isso? </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red-darken-1" variant="text" @click="dialog = false">
          Não
        </v-btn>
        <v-btn color="blue-darken-1" variant="text" @click="bugRealizado">
          Sim
          <v-progress-circular
            v-if="this.isLoading"
            class="ml-2"
            indeterminate
            size="20"
          />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/**
 * @module ModalBugRealizado
 * @desc Modal que faz confirmação da alteração de status.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o diálogo
 * está aberto ou fechado.
 * @vue-data {boolean} [isLoading=false] - Loader da página.
 */
import axios from 'axios';

import store from '@/store/store';

export default {
  props: {
    id: Number,
  },
  emits: ['bugRealizado'],
  data() {
    return {
      dialog: false,
      isLoading: false,
    };
  },
  methods: {
    /**
     * Altera o status do bug.
     */
    async bugRealizado() {
      try {
        this.isLoading = true;
        const apiUrl = process.env.VUE_APP_API_URL;
        await axios.patch(
          `${apiUrl}/api/v1/bug/${this.id}/atualizar-status`,
          {
            status: 'REALIZADO',
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );

        const idProjeto = this.$route.params.idProjeto;

        this.$toast.success('Bug atualizado!');
        this.$emit('bugRealizado');
        this.$router.push(`/projects/${idProjeto}/Bugs/${this.id}`);
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.msg);
      } finally {
        this.dialog = false;
        this.isLoading = false;
      }
    },
  },
};
</script>
